import useMyCase from "../myCase/useMyCase";
import {orientationLockState} from "./orientationRules";
import {setFastOrientationSeconds} from "../video/utils/fastOrientation";

// App-level "you still owe orientation" flag. Home already knows this from
// its own case fetch; App needs the same answer to keep sidebar, permalinks,
// and deep-links from skipping the required watch.
const useOrientationLock = ({user, videos, videosReady, watchHistory}) => {
  const {status, caseData} = useMyCase(user);
  // QA/Sandbox test users only (fastOrientation.js). Set during App's render,
  // before any child calls isCompleted; cleared on sign-out or another user.
  setFastOrientationSeconds(
    user?.customer_id ? caseData?.fastOrientationSeconds : null,
  );
  return orientationLockState({
    caseStatus: user?.customer_id ? status : "error",
    referrals: caseData?.referrals ?? [],
    videos,
    videosReady: Boolean(videosReady),
    watchHistory: watchHistory ?? {},
  });
};

export default useOrientationLock;
